import { BASE_ADMIN_API_ROOT_PATH } from '../../shared/api/constants/path.constants';

const ADMIN_INVITATIONS_API_ROOT = `${BASE_ADMIN_API_ROOT_PATH}/invitations`;

export const ADMIN_INVITATIONS_API_PATHS = {
  GET_INVITATIONS: `${ADMIN_INVITATIONS_API_ROOT}`,
  GET_INVITATION_BY_ID: (invitationId: string) => `${ADMIN_INVITATIONS_API_ROOT}/${invitationId}`,
};
